import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ReactNode } from "react";
import Flex from "./Flex";

interface SimpleAccordionProps {
  accordionSummaryContent: ReactNode;
  accordionDetailsContent: ReactNode;
  expanded?: boolean;
  onClickHandler?: () => void;
}

export const SimpleAccordion = ({
  accordionSummaryContent,
  accordionDetailsContent,
  expanded,
  onClickHandler,
}: SimpleAccordionProps) => {
  return (
    <Accordion expanded={expanded} sx={{ boxShadow: "none" }}>
      <AccordionSummary
        disableRipple
        onClick={(e: any) => {
          if (
            e.target.className?.includes("MuiButtonBase-root") ||
            e.target.className?.includes("MuiBackdrop-root")
          )
            return;

          onClickHandler?.();
        }}
        expandIcon={
          <ExpandMoreIcon
            sx={{ cursor: "pointer" }}
            onClick={() => onClickHandler?.()}
          />
        }
        sx={{
          color: "primary.main",
          bgcolor: "#1A1A1A0D",
          height: "40px",
          "&.Mui-expanded": {
            minHeight: "30px",
          },
          minHeight: "30px",
        }}
      >
        <Flex
          width={"100%"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          {accordionSummaryContent}
        </Flex>
      </AccordionSummary>
      <AccordionDetails style={{ padding: 0 }}>
        {accordionDetailsContent}
      </AccordionDetails>
    </Accordion>
  );
};
